import React, { memo } from 'react';
import { clsb } from 'js/utils/classNames.util';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

import * as Types from './types';

import '../../FormFields.scss';
import style from './FieldBottomMessage.scss';

export const FieldBottomMessageBare: React.FC<Types.IFieldBottomMessageProps> = ({ meta, hint, classNames }) => (
    <>
        {hint && <span className={`${clsb([style, classNames], ['hint'])}`}>{hint}</span>}

        {meta?.error && meta?.touched && !meta?.active && (
            <ErrorMessage error={meta?.error || meta?.submitError} classNames={{ error: style.error, ...classNames }} />
        )}
    </>
);

export const FieldBottomMessage = memo(FieldBottomMessageBare);
